import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { setRows } from '../../../Redux/actions/rowActions';
import { useCurrency } from '../../Layouts/currencyContext';
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from './purchaseOrder2/tooltip';

const ItemGridView = ({ itemData, currencyPrecision,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount, isVatExcluded,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal }) => {
  const apiService = new ApiService();
  const dispatch = useDispatch();

  const rows = useSelector((state) => state.rows.rows);

  // const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0);
  const calculatedTotal = rows.reduce((sum, row) => {
    const qty = parseFloat(row?.qty) || 0;
    const unitPrice = parseFloat(row?.baseAmount) || 0;
    let final = (unitPrice * qty)
    return sum + (final);
  }, 0);

  useEffect(() => {
    const getItems = async () => {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);

      const formattedRowsPromises = itemData?.poDetails
        ?.map(async (detail, index) => {
          const params = new URLSearchParams();
          params.append('ItemNo', detail.itemCode || '');
          const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
          let selecteditem = response?.data?.result[0];
          const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
          const selectedVat = vat.data.result?.find((tax) => tax?.description === detail?.vatDesc);

          if (!selecteditem) {
            console.error(`Selected item with description ${detail?.itemDescription} not found`);
            return null;
          }
          const amount = Number(detail?.qty || 0) * Number(detail?.unitPrice || 0);

          const discountPerc = Number(overallDiscount || 0);

          const discountAmount = (amount * discountPerc) / 100;

          const calculatedAmount = amount - discountAmount;

          const vatRate = Number(selectedVat?.rate || 0);

          const vatAmount = (calculatedAmount * vatRate) / 100;

          const totalAmount = calculatedAmount + vatAmount;
          return {
            requisitionNo: itemData.requisitionNo || '',
            srno: detail?.srno,
            ItemNo: detail.itemCode,
            itemDescription: detail?.itemDescription,
            qty: detail?.qty,
            stock: selecteditem.convToInvUOM * detail?.qty,
            baseQty: selecteditem.convToInvUOM,
            uom: detail?.uom,
            baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
            discount: discountPerc,
            discountAmount: Number(discountAmount).toFixed(currencyPrecision),
            calculatedAmount: Number(calculatedAmount).toFixed(currencyPrecision),
            vat: vatRate,
            vatDec: selectedVat?.description,
            vatAmount: Number(vatAmount).toFixed(currencyPrecision),
            amount: Number(totalAmount).toFixed(currencyPrecision),
            specification: detail?.specification || "",
          };
        })
        .filter((row) => row !== null);
      const formattedRows = await Promise.all(formattedRowsPromises);
      if (formattedRows?.length > 0) {
        setRows(formattedRows?.reverse());
        dispatch(setRows(formattedRows));
      }
    };
    if (itemData) {
      getItems();
    }
  }, [itemData]);

  useEffect(() => {
    const total = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );
    const vatAmount = rows.reduce(
      (sum, row) => sum + Number(row?.vatAmount || 0),
      0
    );
    const vat = rows[0]?.vat || 0
    let calculatedfinal = calculatedTotal
    const discountAmt = (calculatedTotal * overallDiscount) / 100;
    let afterdiscount = (calculatedTotal - discountAmt)
    const grandtotals = (afterdiscount + vatAmount)
    const grandtotalsvat = (afterdiscount + vatAmount)
    let final = overallDiscount === 0 ? grandtotalsvat : grandtotals
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmount)
  }, [rows, overallDiscount]);

  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-Input w-100"
            min="0"
            max="100"
            value={overallDiscount} disabled
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        <table>
          <thead className="dynoTable">
            <tr>
              <th>Sr no</th>
              <th>Item No</th>
              <th>Description</th>
              <th>Item Specs</th>
              <th>Qty</th>
              <th>Packing UOM</th>
              <th>Inventory Qty</th>
              <th>Unit Price</th>
              {/* <th>Discount</th> */}
              <th>VAT %</th>
              <th>VAT Amount</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={index}>
                <td className="m-0 p-0">
                  <input className="p-2" type="text" value={index + 1} disabled style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0 itemCol">
                  <input className="p-2 w-100" disabled value={row.ItemNo} />
                </td>
                <td className="m-0 p-0 descriptionCol">
                  <input className="p-2 w-100" disabled value={row.itemDescription} />
                </td>
                <Tooltip text={row?.specification}>
                  <td className="m-0 p-0">
                    <input className="p-2" disabled value={row.specification} style={{ width: '350px' }} />
                  </td>
                </Tooltip>

                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.qty} style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.uom} style={{ width: '140px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.stock || 0} style={{ width: '140px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.baseAmount} style={{ width: '120px' }} />
                </td>
                {/* <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.discount} style={{ width: '120px' }} />
                </td> */}
                <td className="m-0 p-0">
                  <input className="p-2" type="text" style={{ width: '150px' }} value={(row?.vatDec) || 0} disabled />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input
                    className="p-2"
                    disabled
                    value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0}
                    style={{ width: '120px' }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemGridView;
